import React from 'react';
import { useScrollReveal } from '../../hooks/useScrollReveal';

interface PageHeaderProps {
    prefix: string;
    highlight: string;
    description: string;
    breakLine?: boolean;
}

const PageHeader: React.FC<PageHeaderProps> = ({
    prefix,
    highlight,
    description,
    breakLine = false,
}) => {
    const { ref, isVisible } = useScrollReveal();

    return (
        <section className="container mx-auto px-4 mb-32 text-center relative">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/20 blur-[120px] rounded-full -z-10" />

            <div
                ref={ref}
                className={isVisible ? 'animate-reveal-up' : 'opacity-0'}
            >
                <h1 className="text-4xl md:text-6xl font-semibold tracking-[-0.04em] leading-tight mb-6">
                    {prefix} {breakLine && <br />}
                    <span className="text-gradient-accent">
                        {highlight}
                    </span>
                </h1>
                <p className="text-muted-foreground text-base md:text-lg">
                    {description}
                </p>
            </div>
        </section>
    );
};

export default PageHeader;
